export default __webpack_public_path__ + "static/Team-Approach-to-Treating-HP@2x-5eb74d859af7d3f1f89245cb3f246a48.png";